import ls from 'local-storage';

import { toISODate, getNow } from '@libs/NwMoment';

const STORAGE_PREFIX = 'nw_config_statement';

const getStorageKey = (contactType, statementType, suffix) =>
    `${STORAGE_PREFIX}_${contactType}_${statementType}_${suffix}`;

export const getFilterStorageKey = (contactType, statementType) => getStorageKey(contactType, statementType, 'filters');

export const getExpandStorageKey = (contactType, statementType) => getStorageKey(contactType, statementType, 'expand');

const createDefaultRange = () => [toISODate(getNow().startOf('year')), toISODate(getNow().endOf('year'))];

const BASE_DEFAULT_FILTERS = () => ({
    period: 'year',
    range: createDefaultRange(),
    clientStatus: 'All',
    paymentStatus: 'All',
    invoiceStatus: 'All',
    modelStatus: 'All',
});

const DEFAULT_OVERRIDES = {
    model: {
        model: {
            clientStatus: 'Invoiced',
            paymentStatus: 'NotPaid',
        },
    },
    agency: {
        agency: {
            clientStatus: 'Paid',
            paymentStatus: 'NotPaid',
        },
    },
    client: {
        client: {
            paymentStatus: 'NotPaid',
        },
    },
    service: {
        service: {
            paymentStatus: 'NotPaid',
        },
    },
};

const sanitizeRange = (range) => {
    if (Array.isArray(range) && range.length === 2) {
        return range.map((date) => (typeof date === 'string' ? date : toISODate(date)));
    }
    return createDefaultRange();
};

export const getDefaultFilters = (contactType, statementType) => {
    const base = BASE_DEFAULT_FILTERS();
    const contactOverrides = DEFAULT_OVERRIDES[contactType] || {};
    const overrides = contactOverrides[statementType] || contactOverrides.default || {};
    return {
        ...base,
        ...overrides,
    };
};

export const loadFilters = (contactType, statementType) => {
    const saved = ls.get(getFilterStorageKey(contactType, statementType));
    return saved || null;
};

export const saveFilters = (contactType, statementType, filters) => {
    ls.set(getFilterStorageKey(contactType, statementType), filters);
};

export const loadExpand = (contactType, statementType) => {
    const saved = ls.get(getExpandStorageKey(contactType, statementType));
    return typeof saved === 'boolean' ? saved : null;
};

export const saveExpand = (contactType, statementType, value) => {
    ls.set(getExpandStorageKey(contactType, statementType), value);
};

export const resolveFilters = (contactType, statementType) => {
    const defaults = getDefaultFilters(contactType, statementType);
    const saved = loadFilters(contactType, statementType);

    if (!saved) {
        return defaults;
    }

    return {
        ...defaults,
        ...saved,
        range: sanitizeRange(saved.range || defaults.range),
    };
};

export const isStatementFiltered = (filtersToCheck) => {
    if (
        filtersToCheck.statementTypeFilter !== 'Real' ||
        filtersToCheck.clientStatus !== 'Invoiced' ||
        filtersToCheck.paymentStatus !== 'All' ||
        filtersToCheck.invoiceStatus !== 'All' ||
        filtersToCheck.familiesFilter !== 'All' ||
        filtersToCheck.billingInfoFilter !== 'All' ||
        filtersToCheck.searchTerm
    ) {
        return true;
    }
    return false;
};
